import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import Unauthorized from '../common/Error/Unauthorized/Unauthorized';
import BCLLoading from "../common/Loading/BCLLoading";

import { Configuration } from "../../configs/Configuration";
import ConfigDataFetcher from "../../dataFetchers/configsDataFetcher";
import TranslationDataFetcher from "../../dataFetchers/translationsDataFetcher";
import { setAuthToken } from '../../helpers/authHelper';
import { DASHBOARD_HOME_PATH, DASHBOARD_SURVEY_PATH, PREFERENCES_BASE_PATH } from '../../constants/paths';
import { fetchUserHash } from '../../dataFetchers/noAuthDataFetcher';
import { parseQueryParams } from '../../helpers/URLHelper';
import { SSO_DESTINATION ,PRODUCT_TYPE_CONFIG} from '../../constants/common';
import { bidgelyStorage } from '../../helpers/storageHelper';
import { getBECompatibleLocale } from "../../helpers/helper";


class SsoAuthenticationLayer extends React.Component {
  constructor(props) {
    super(props);
    this.configuration = Configuration.getConfiguration();
  }

  state = {
    errorCode: null
  };

  componentDidMount() {
    let parsedString = null;
    this.props.fetchConfigData({ pilotId:this.configuration.pilotId , configType: PRODUCT_TYPE_CONFIG['WEB'], isPublic: true});
    if (this.props.location.search !== "") {
      parsedString = parseQueryParams(this.props.location.search);
      this.setState({
        errorCode: parsedString["error-code"]
      });
    }
    if (!parsedString["error-code"]) {
      let path = DASHBOARD_HOME_PATH;
      let destination = parsedString.destination;
      let token = parsedString.token;
      let uuid = parsedString.uuid;
      // query param to show cobrowsing banner
      let scb = parsedString.scb;
      let configuration = Configuration.getConfiguration();

      setAuthToken(token);
      bidgelyStorage.setItem('adminAuthToken', token);
      bidgelyStorage.setItem('sso', true);
      if (scb === "1") {
        bidgelyStorage.setItem('isCobrowsing', true);
      }
      fetchUserHash(uuid, configuration.pilotId).then(
        (userHash) => {
          bidgelyStorage.setItem('userHash', userHash);
          switch (destination) {
            case SSO_DESTINATION.DASHBOARD:
              path = DASHBOARD_HOME_PATH
              break;
            case SSO_DESTINATION.SURVEY:
              path = DASHBOARD_SURVEY_PATH
              break;
            case SSO_DESTINATION.PREFERENCES:
              path = PREFERENCES_BASE_PATH
              break;
            default:
              break;
          }
          this.props.history.replace(path);
        }
      );
    }
  }
  componentDidUpdate(prevProps){
    if (!prevProps.configs.data && this.props.configs && this.props.configs.data) {
      let locale = getBECompatibleLocale(this.props.configs.data);
      this.props.fetchAllTranslations({ pilotId: this.configuration.pilotId, locale: locale, tagType: PRODUCT_TYPE_CONFIG['WEB'], isPublic: true});
      this.setState({
        locale
      });
    }
  }

  render() {
    const { translationsData } = this.props;
    const { errorCode,locale } = this.state;
    return(
      <> { (errorCode && locale && translationsData.data)  ?
        <Unauthorized errorCode={errorCode} locale={locale} translationsData={translationsData} /> : <BCLLoading />}
      </>
    );
  }
}

  const mapStateToProps = (state) => {
    return {
      configs: state.configs,
      translationsData: state.translationsData,

    };
  };


const mapDispatchToProps = dispatch => {
  return {
    fetchConfigData: options => dispatch(ConfigDataFetcher.fetchConfigData(options)),
    fetchAllTranslations: options => dispatch(TranslationDataFetcher.fetchAllTranslations(options))
    };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SsoAuthenticationLayer));


